import { setUpModals } from '~/components/shared/controllers/modalController';

const moreProvidersLink = document.querySelector('[data-more-providers-link]');

const loadMoreProviders = () => {
  updateButtonToPending();
  const url = createMoreProvidersUrl();
  fetch(url)
    .then((response) => response.text())
    .then((data) => {
      handleNewProvidersData(data);
    });
};

const updateButtonToPending = () => {
  const innerText = moreProvidersLink.innerText;
  moreProvidersLink.dataset.innerText = innerText;
  moreProvidersLink.innerText = '';
  moreProvidersLink.classList.add('loading');
};

const createMoreProvidersUrl = () => {
  const currentProviderPage = moreProvidersLink.getAttribute(
    'data-current-provider-page',
  );
  const nextPage = parseInt(currentProviderPage) + 1;
  const currentHref = window.location.href;
  const url = new URL(currentHref);
  url.searchParams.set('page', nextPage);
  url.searchParams.set('additional_listings', 'true');
  moreProvidersLink.setAttribute('data-current-provider-page', nextPage);
  return url;
};

const handleNewProvidersData = (data) => {
  const parser = new DOMParser();
  const html = parser.parseFromString(data, 'text/html');
  const allCards = document.querySelectorAll('.cards');
  const cards = allCards[allCards.length - 1];
  const newCards = html.querySelector('.cards');

  if (!newCards) {
    removeMoreProvidersLink(cards);
  } else {
    addNewModals(html);
    addNewCards(cards, newCards);
    updatePageScroll(cards, newCards);
    updateButtonToComplete();
    setUpModals();
    setTimeout(() => {
      newCards.classList.remove('new-cards');
    }, 10);
  }
};

const removeMoreProvidersLink = (cards) => {
  moreProvidersLink.remove();
  const noMoreProviders = document.createElement('h4');
  noMoreProviders.innerText = 'No more providers meeting your criteria to show';
  noMoreProviders.style = 'text-align: center;';
  cards.insertAdjacentElement('afterend', noMoreProviders);
};

const addNewModals = (html) => {
  const newModals = html.querySelector('.marketplace_landing_page__modals');
  const newModalsContent = newModals.innerHTML;
  const currentModals = document.querySelector('[data-modal-container]');
  currentModals.insertAdjacentHTML('beforeend', newModalsContent);
};

const addNewCards = (cards, newCards) => {
  newCards.classList.add('new-cards');
  cards.insertAdjacentElement('afterend', newCards);
};

const updatePageScroll = (cards) => {
  // this method improves the user experience.  It is not perfect but it is better than it is without it.

  if (window.innerWidth < 1290) {
    return;
  }

  const scrollY = window.scrollY;
  const cardsTop = cards.getBoundingClientRect().top;
  const scrollPoint = scrollY + cardsTop + 100;
  if (scrollPoint < scrollY) {
    window.scrollTo(0, scrollPoint);
  }
};

const updateButtonToComplete = () => {
  const updatedMoreProvidersLink = document.querySelector(
    '[data-more-providers-link]',
  );
  const innerText = updatedMoreProvidersLink.dataset.innerText;
  updatedMoreProvidersLink.classList.remove('loading');
  updatedMoreProvidersLink.innerText = innerText;
};

if (moreProvidersLink) {
  moreProvidersLink.addEventListener('click', function () {
    loadMoreProviders();
  });
}
